export type ArActionType = "DENIAL_ACTION" | "BALANCE_ADJUSTMENT";

// Every DenialAction + BalanceAdjustmentAction value. Display copy only — the
// set of *selectable* actions comes from the backend (action-options endpoint).
type ArActionValue =
  | "RESUBMIT"
  | "APPEAL"
  | "CALL_PAYER"
  | "SUBMIT_QUESTIONNAIRE"
  | "SENT_TO_SECONDARY"
  | "PATIENT_RESPONSIBILITY"
  | "WRITE_OFF"
  | "CONTRACT_ADJUSTMENT"
  | "DUPLICATE"
  | "COMPLETED"
  | "NEEDS_REVIEW";

const AR_ACTION_LABELS: Record<ArActionValue, string> = {
  RESUBMIT: "Resubmit",
  APPEAL: "Appeal",
  CALL_PAYER: "Call Payer",
  SUBMIT_QUESTIONNAIRE: "Submit Questionnaire",
  SENT_TO_SECONDARY: "Sent to Secondary",
  PATIENT_RESPONSIBILITY: "Patient Responsibility",
  WRITE_OFF: "Write Off",
  CONTRACT_ADJUSTMENT: "Contract Adjustment",
  DUPLICATE: "Duplicate",
  COMPLETED: "Completed",
  NEEDS_REVIEW: "Needs Review",
};

export function arActionLabel(action: string | null | undefined): string {
  if (!action) return "";
  return (AR_ACTION_LABELS as Record<string, string>)[action] ?? action;
}

// Raw values are what the search endpoint filters on; labels are display only.
export const AR_ACTION_OPTIONS = Object.entries(AR_ACTION_LABELS).map(
  ([value, label]) => ({ value, label }),
);
